// import request from '@/api/ajax_request.js'
import request from 'axios'
var print_url = "http://localhost:3000/print"
var qs = require('qs');

var device_api ={

    post_printer :function(data,params={}){

        return request({
                url:print_url,
                method : 'post',
                params,
                data:qs.stringify(data)
        })  
    },
    last_printer :function(){
        return request({
                url:print_url+'/last',
                method : 'get'
        })
    },
    open_box :function(){
        return request({
                url:print_url+'/open',
                method : 'get'
        })
    },
    load_weight :function(){
        var weighter_url = "";
        return request({
                url:weighter_url+'/open',
                method : 'get'
        })
    }
};

export default device_api;





// WEBPACK FOOTER //
// ./src/api/local_device.js